import React from 'react';
import { Accordion } from './Accordion';
import { BonusAccordion } from './BonusAccordion';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { PurchasePopup } from './PurchasePopup';
import { ComparisonTable } from './ComparisonTable';
import { Star, ShieldAlert, Settings, Gift, BookOpen, Crown } from 'lucide-react';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wsZLuwesYPeEQvNj9nvaHq/ChatGPT_Image_Jun_22__2026__10_30_04_AM-removebg-preview.png';
const TOMO_IMAGES = ['https://cdn.magicpatterns.com/uploads/ny7YSz7hNZdHmBxzTNHyay/ChatGPT_Image_Jun_30,_2026,_12_25_55_PM.png', 'https://cdn.magicpatterns.com/uploads/ijVBgCWKD1VcAWwutT6FzR/ChatGPT_Image_Jun_30,_2026,_12_27_05_PM.png', 'https://cdn.magicpatterns.com/uploads/25mVuE8XMZwx2wvT4Ldhjw/ChatGPT_Image_Jun_30,_2026,_12_29_07_PM.png', 'https://cdn.magicpatterns.com/uploads/nUfz4XCWB4URCjFsEi3Usr/ChatGPT_Image_Jun_30,_2026,_12_31_10_PM.png', 'https://cdn.magicpatterns.com/uploads/4ctxyMjnm4pYJT6EbhTSEq/ChatGPT_Image_Jun_30,_2026,_12_36_02_PM.png', 'https://cdn.magicpatterns.com/uploads/qR6TtpKd8JyPjfWL1zA7oz/ChatGPT_Image_Jun_30,_2026,_12_38_49_PM.png'];
const BONUS_IMAGES = ['https://cdn.magicpatterns.com/uploads/p4H7Zs4HxVP34jX756h8qg/Screenshot_2026-06-22_at_3.57.07_PM.png', 'https://cdn.magicpatterns.com/uploads/pNkmfiKZJTMs3XXFcZ8dUo/Screenshot_2026-06-22_at_3.58.24_PM.png', 'https://cdn.magicpatterns.com/uploads/cs5mGkjsX9yXwZdxDh3Gfn/Screenshot_2026-06-22_at_3.58.47_PM.png', 'https://cdn.magicpatterns.com/uploads/ibYX58L7sP1hH2uUNCpb4P/Screenshot_2026-06-22_at_4.14.08_PM.png', 'https://cdn.magicpatterns.com/uploads/4YbNuvTv9K6VcSapbmgF48/Screenshot_2026-06-22_at_4.16.34_PM.png'];
export function SalesPage() {
  const modules = [{
    title: '📘 TOMO 1: FUNDAMENTOS DE LA ARQUERA MODERNA',
    image: TOMO_IMAGES[0],
    content: <div className="space-y-4" data-id="element-81" data-mp="2m9usil8q9ji3">
          <div data-id="element-82" data-mp="2maw8930ouu65">
            <h4 className="font-bold text-gray-800" data-id="element-83" data-mp="q5ofi76z6yc3">
              Capítulo 1: El rol real de la arquera en el hockey actual
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-84" data-mp="v5avgoe6usol">
              <li data-id="element-85" data-mp="z5l98n882ne0">Evolución del puesto</li>
              <li data-id="element-86" data-mp="z4jplud54sko">Qué esperan los entrenadores modernos</li>
              <li data-id="element-87" data-mp="145pjhvijelvs">Errores que frenan la progresión</li>
              <li data-id="element-88" data-mp="1433b5tnto2ci">Cómo evaluar tu nivel actual</li>
            </ul>
          </div>
          <div data-id="element-89" data-mp="193r8ex2n9ff6">
            <h4 className="font-bold text-gray-800" data-id="element-90" data-mp="1926ftczw46jy">
              Capítulo 2: Posición base y biomecánica
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-91" data-mp="1iuc6mjeeohxk">
              <li data-id="element-92" data-mp="1iw6ti398mk4a">Posición lista, altura ideal y distribución del peso</li>
              <li data-id="element-93" data-mp="1mue0i6dwg72a">Errores frecuentes y ajustes según distancia de tiro</li>
            </ul>
          </div>
          <div data-id="element-94" data-mp="1rwbotf15ps23">
            <h4 className="font-bold text-gray-800" data-id="element-95" data-mp="1rsnuidnw11mb">
              Capítulo 3: Movimientos específicos
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-96" data-mp="26xs9kfzr25vf">
              <li data-id="element-97" data-mp="26z3e4i10rhnl">
                Shuffle, paso cruzado, recuperaciones y cambios de dirección
              </li>
              <li data-id="element-98" data-mp="220s529ijtb6f">Cómo desplazarte sin perder equilibrio</li>
            </ul>
          </div>
          <div data-id="element-99" data-mp="1x1oxahb6oqur">
            <h4 className="font-bold text-gray-800" data-id="element-100" data-mp="1x1ff3fwdrnzm">
              Capítulo 4: Equipamiento
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-101" data-mp="2po9x865q6b9x">
              <li data-id="element-102" data-mp="2pni1mvc4odjn">Cómo elegir casco, kickers y guantes</li>
              <li data-id="element-103" data-mp="2kox2kz8m3zws">Ajustes del equipo y errores que afectan el rendimiento</li>
            </ul>
          </div>
        </div>
  }, {
    title: '🧤 TOMO 2: ATAJADAS Y RECURSOS TÉCNICOS',
    image: TOMO_IMAGES[1],
    content: <div className="space-y-4" data-id="element-104" data-mp="2busf8psot6m0">
          <div data-id="element-105" data-mp="38faxqymhuevl">
            <h4 className="font-bold text-gray-800" data-id="element-106" data-mp="38ft26ijb7zel">
              Capítulo 1: Bloqueos con piernas
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-107" data-mp="33n9fmw2n9txn">
              <li data-id="element-108" data-mp="2o5i3zf3ilfjl">Tiros bajos, tiros medios y rebotes</li>
            </ul>
          </div>
          <div data-id="element-109" data-mp="2t4uss5dy4wot">
            <h4 className="font-bold text-gray-800" data-id="element-110" data-mp="2t5e7zec7p6z5">
              Capítulo 2 & 3: Uso de guantes
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-111" data-mp="2f6obo0x7vbbu">
              <li data-id="element-112" data-mp="2j6exrrbst3a1">Guante izquierdo: Desvíos, atrapes y reacciones</li>
              <li data-id="element-113" data-mp="2j8rpuxb9su0t">Guante derecho: Despejes, bloqueos y coberturas</li>
            </ul>
          </div>
          <div data-id="element-114" data-mp="36yvgm43d0zae">
            <h4 className="font-bold text-gray-800" data-id="element-115" data-mp="3bvcgfvjx923b">
              Capítulo 4: Recursos avanzados
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-116" data-mp="2y4qw02etkk3b">
              <li data-id="element-117" data-mp="2y2ed9n18m5p7">
                Split save, extensiones, salidas agresivas y recursos de
                emergencia
              </li>
            </ul>
          </div>
          <div data-id="element-118" data-mp="3ptu1tmmcu2i2">
            <h4 className="font-bold text-gray-800" data-id="element-119" data-mp="3ptahy0d5941e">
              Capítulo 5: Control de rebotes
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-120" data-mp="1j74qtrrl0fnr">
              <li data-id="element-121" data-mp="1j5jsdr25cckm">Hacia dónde despejar, rebotes peligrosos vs seguros</li>
            </ul>
          </div>
        </div>
  }, {
    title: '🧠 TOMO 3: LECTURA DE JUEGO Y TOMA DE DECISIONES',
    image: TOMO_IMAGES[2],
    content: <div className="space-y-4" data-id="element-122" data-mp="1nxbcpjuplm2b">
          <div data-id="element-123" data-mp="1nz61j993pybo">
            <h4 className="font-bold text-gray-800" data-id="element-124" data-mp="1nympg964u45k">
              Capítulo 1: Lectura corporal de la atacante
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-125" data-mp="v9770yc518zm">
              <li data-id="element-126" data-mp="vb0bc6za3h4g">
                Orientación de hombros, posición del palo e indicadores previos
                al tiro
              </li>
            </ul>
          </div>
          <div data-id="element-127" data-mp="156bx3993tolp">
            <h4 className="font-bold text-gray-800" data-id="element-128" data-mp="155sd7mzw8q51">Capítulo 2: Ángulos</h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-129" data-mp="2lkk6010ybzev">
              <li data-id="element-130" data-mp="2gmscj2kns58k">
                Cómo cerrar espacios, posicionamiento según ubicación de la
                pelota y ajustes dinámicos
              </li>
            </ul>
          </div>
          <div data-id="element-131" data-mp="2sotdqt9sca11">
            <h4 className="font-bold text-gray-800" data-id="element-132" data-mp="2soa6c6hrh419">
              Capítulo 3: Situaciones de partido
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-133" data-mp="2xoxvemmfjasu">
              <li data-id="element-134" data-mp="32mzgfd3f1k6y">
                Mano a mano, dos contra una, desbordes, centros y tiros cruzados
              </li>
            </ul>
          </div>
          <div data-id="element-135" data-mp="250s9vxnjxhry">
            <h4 className="font-bold text-gray-800" data-id="element-136" data-mp="2511ybgsy7gvj">
              Capítulo 4: Cuándo salir y cuándo esperar
            </h4>
            <ul className="list-disc pl-5 text-sm mt-1 space-y-1" data-id="element-137" data-mp="2exevionpccv1">
              <li data-id="element-138" data-mp="2ew3rqou9b53x">Factores de decisión y errores más comunes</li>
            </ul>
          </div>
        </div>
  }, {
    title: '🎯 TOMO 4: CÓRNERS CORTOS Y SITUACIONES ESPECIALES',
    image: TOMO_IMAGES[3],
    content: <div className="space-y-4" data-id="element-139" data-mp="1r7kf5x46c661">
          <ul className="list-disc pl-5 text-sm space-y-2" data-id="element-140" data-mp="1r6j43sn5rjob">
            <li data-id="element-141" data-mp="8cg2wis6n0lj">
              <span className="font-bold" data-id="element-142" data-mp="8czfdjz2cws6">Capítulo 1:</span> La psicología del
              córner corto
            </li>
            <li data-id="element-143" data-mp="4bmbhffj73nw">
              <span className="font-bold" data-id="element-144" data-mp="4bw5rf7lzwze">Capítulo 2:</span> Posicionamiento
              inicial
            </li>
            <li data-id="element-145" data-mp="3vj8nbvcemcfu">
              <span className="font-bold" data-id="element-146" data-mp="3qikvj7gcprkk">Capítulo 3:</span> Lectura del
              arrastre
            </li>
            <li data-id="element-147" data-mp="3ljrith8w24lg">
              <span className="font-bold" data-id="element-148" data-mp="3lk9lavm59f1t">Capítulo 4 & 5:</span> Desvíos y
              Rebotes
            </li>
            <li data-id="element-149" data-mp="3grpz5a9e5ble">
              <span className="font-bold" data-id="element-150" data-mp="3gr858ka7b9gn">Capítulo 6:</span> Variantes tácticas
              frecuentes
            </li>
            <li data-id="element-151" data-mp="3cojs40egfgdv">
              <span className="font-bold" data-id="element-152" data-mp="37s37hg6grk5j">Capítulo 7:</span> Penales
              australianos (Lectura, timing, errores frecuentes)
            </li>
          </ul>
        </div>
  }, {
    title: '🏃‍♀️ TOMO 5: ENTRENAMIENTO ESPECÍFICO DE ARQUERAS',
    image: TOMO_IMAGES[4],
    content: <div className="space-y-4" data-id="element-153" data-mp="qhx3s7b2skxc">
          <ul className="list-disc pl-5 text-sm space-y-2" data-id="element-154" data-mp="qiyhykne1nja">
            <li data-id="element-155" data-mp="ukk0alioyu0v">
              <span className="font-bold" data-id="element-156" data-mp="uj0mr2of6x2s">Capítulo 1:</span> Cómo entrenar sin
              entrenador de arqueras
            </li>
            <li data-id="element-157" data-mp="gk0u7jxsdy1c">
              <span className="font-bold" data-id="element-158" data-mp="gmn7m07cz7rh">Capítulo 2 & 3:</span> Entrenamiento
              de reflejos y velocidad lateral
            </li>
            <li data-id="element-159" data-mp="6u7p91s5gh62">
              <span className="font-bold" data-id="element-160" data-mp="6to6jiuodoqz">Capítulo 4 & 5:</span> Reacción visual
              y coordinación
            </li>
            <li data-id="element-161" data-mp="bnakdeckryod">
              <span className="font-bold" data-id="element-162" data-mp="3tz5nkwpd5uup">Capítulo 6 & 7:</span> Movilidad
              específica y potencia para arqueras
            </li>
            <li data-id="element-163" data-mp="2txg5g929amz">
              <span className="font-bold" data-id="element-164" data-mp="2tdxfxbl6i7w">Capítulo 8:</span> Prevención de
              lesiones
            </li>
          </ul>
        </div>
  }, {
    title: '🛡️ TOMO 6: FORTALEZA MENTAL Y RENDIMIENTO',
    image: TOMO_IMAGES[5],
    content: <div className="space-y-4" data-id="element-165" data-mp="35dirr5rg2jur">
          <ul className="list-disc pl-5 text-sm space-y-2" data-id="element-166" data-mp="35esptuyars1e">
            <li data-id="element-167" data-mp="31dgztobih4so">
              <span className="font-bold" data-id="element-168" data-mp="31e0jb9gt818t">Capítulo 1 & 2:</span> El miedo al
              error y cómo recuperarte después de un gol
            </li>
            <li data-id="element-169" data-mp="3addi987b57fa">
              <span className="font-bold" data-id="element-170" data-mp="3adncj7zdy0qs">Capítulo 3:</span> Concentración
              durante todo el partido
            </li>
            <li data-id="element-171" data-mp="3oc3igwpfbn7v">
              <span className="font-bold" data-id="element-172" data-mp="3obln02al5d10">Capítulo 4 & 5:</span> Comunicación
              con la defensa y liderazgo desde el arco
            </li>
            <li data-id="element-173" data-mp="1xalhxhqh35q">
              <span className="font-bold" data-id="element-174" data-mp="1xtuuptbij85">Capítulo 6 & 7:</span> Rutinas pre y
              post partido
            </li>
            <li data-id="element-175" data-mp="3t56ah0ejyoly">
              <span className="font-bold" data-id="element-176" data-mp="3t4n2ocim9gln">Capítulo 8:</span> Análisis de
              rendimiento
            </li>
          </ul>
        </div>
  }];
  const bonuses = [{
    title: '🎁 Bono 1: Atlas Visual de Situaciones de Arquera',
    image: BONUS_IMAGES[0],
    content: <div data-id="element-177" data-mp="uh42vvpl1i3z">
          <p className="font-bold mb-2" data-id="element-178" data-mp="uhnlzfqyycjl">Más de 100 diagramas:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-179" data-mp="poazpc9rihu0">
            <li data-id="element-180" data-mp="kphu060pvv4e">Mano a mano</li>
            <li data-id="element-181" data-mp="kqszca9t9axm">Centros</li>
            <li data-id="element-182" data-mp="knwzuhibee72">Desbordes</li>
            <li data-id="element-183" data-mp="goo81i6u4qe5">Córners</li>
            <li data-id="element-184" data-mp="gpfrxvr2kzol">Rebotes</li>
            <li data-id="element-185" data-mp="gq9276p8m7bh">Penales</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 2: 50 Entrenamientos Específicos',
    image: BONUS_IMAGES[1],
    content: <div data-id="element-186" data-mp="18gvlk9r1nmob">
          <p className="font-bold mb-2" data-id="element-187" data-mp="18gdhws21y66d">Clasificados por:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-188" data-mp="14d7fjvi28z56">
            <li data-id="element-189" data-mp="14ftn3v4ybene">Reflejos</li>
            <li data-id="element-190" data-mp="zffd47jshumq">Técnica</li>
            <li data-id="element-191" data-mp="ze47012vgasg">Reacción</li>
            <li data-id="element-192" data-mp="zh07nx63tdkl">Velocidad</li>
            <li data-id="element-193" data-mp="3p3y5ue3oz9g4">Córners</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 3: Sistema de Autoevaluación',
    image: BONUS_IMAGES[2],
    content: <div data-id="element-194" data-mp="3k7hhpjwhsv31">
          <p className="font-bold mb-2" data-id="element-195" data-mp="1zn2he7o389j4">Planillas para medir:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-196" data-mp="1zox5fuunohrf">
            <li data-id="element-197" data-mp="24ldwoxx5jc8q">Salidas</li>
            <li data-id="element-198" data-mp="24movskfnjvti">Rebotes</li>
            <li data-id="element-199" data-mp="24jsxuw3t1752">Posicionamiento</li>
            <li data-id="element-200" data-mp="28nil9i8qtioi">Comunicación</li>
            <li data-id="element-201" data-mp="28m7k7q6omp13">Córners</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 4: Cuaderno de Partido de la Arquera',
    image: BONUS_IMAGES[3],
    content: <div data-id="element-202" data-mp="2icsdcy3l71cm">
          <p className="font-bold mb-2" data-id="element-203" data-mp="2id23clomt8ib">Registro de:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-204" data-mp="2nc5acbo69osx">
            <li data-id="element-205" data-mp="2nerhwbb2c4b5">Goles recibidos</li>
            <li data-id="element-206" data-mp="2sb8778u00opt">Errores</li>
            <li data-id="element-207" data-mp="2sd2taqh0amvh">Aciertos</li>
            <li data-id="element-208" data-mp="2s9nabck7otos">Aprendizajes</li>
            <li data-id="element-209" data-mp="2wd3503cq0jyu">Objetivos</li>
          </ul>
        </div>
  }, {
    title: '🎁 Bono 5: Biblioteca de Corrección de Errores',
    image: BONUS_IMAGES[4],
    content: <div data-id="element-210" data-mp="11zc1zmowcycd">
          <p className="font-bold mb-2" data-id="element-211" data-mp="11ysfrts7rnsj">Los 50 errores más comunes:</p>
          <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-212" data-mp="12156owfy98hq">
            <li data-id="element-213" data-mp="25b0x5zey39ik">Por qué ocurren</li>
            <li data-id="element-214" data-mp="25c2kb298jmgn">Cómo corregirlos</li>
            <li data-id="element-215" data-mp="20by1v6orohns">Ejercicios específicos</li>
          </ul>
        </div>
  }];
  const testimonials = [{
    name: 'Martina',
    city: 'Ciudad de México, México',
    text: 'Siempre dudaba en los mano a mano. Desde que leí el Tomo 3, mi confianza cambió por completo. ¡Atajé 3 penales este torneo!'
  }, {
    name: 'Lucía',
    city: 'Bogotá, Colombia',
    text: 'El material sobre córners cortos vale oro. Ahora sé exactamente dónde pararme y cómo leer a la ejecutora del arrastre.'
  }, {
    name: 'Camila',
    city: 'Santiago, Chile',
    text: 'Entreno sola la mayor parte del tiempo. Los 50 entrenamientos específicos me salvaron la vida. Siento que mejoré muchísimo mi técnica.'
  }, {
    name: 'Sofía',
    city: 'Lima, Perú',
    text: 'Me costaba mucho recuperarme mentalmente después de un gol. La sección de fortaleza mental me ayudó a mantener el foco todo el partido.'
  }, {
    name: 'Valentina',
    city: 'Buenos Aires, Argentina',
    text: 'Increíble la cantidad de información detallada. Los diagramas de posición me corrigieron errores que venía arrastrando hace años.'
  }];
  const problems = ['Dudar en las salidas y quedar a mitad de camino, regalando el gol.', 'Frustración por recibir goles de rebotes mal despejados al centro del área.', 'Falta de confianza para ordenar a la defensa en los córners cortos.', 'Miedo a cometer errores que cuesten el partido y no saber cómo recuperarse mentalmente.', 'Sentir que no tienes un entrenamiento específico para mejorar tu técnica porque entrenas sola.'];
  const faqs = [{
    q: '¿Es para mi nivel?',
    a: 'Sí, el sistema está diseñado tanto para arqueras en formación (infantiles/juveniles) como para aquellas en primera división que buscan pulir detalles técnicos y tácticos.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al realizar el pago, recibirás acceso inmediato a todos los PDFs y bonos directamente en tu correo electrónico. Podrás descargarlos al instante.'
  }, {
    q: '¿Sirve si no tengo entrenador de arqueras?',
    a: '¡Totalmente! El Tomo 5 incluye un plan completo para arqueras que entrenan solas, con rutinas y ejercicios diseñados para hacer sin ayuda.'
  }, {
    q: '¿Puedo leerlo desde el celular?',
    a: 'Sí, todos los archivos están en formato PDF optimizado para leer cómodamente en cualquier dispositivo: celular, tablet o computadora.'
  }];
  const faqItems = faqs.map(faq => ({
    title: faq.q,
    content: <p className="text-gray-600 text-sm leading-relaxed" data-id="element-216" data-mp="1k5cds7z0w6sp">{faq.a}</p>
  }));
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-217" data-mp="1k7feblxsxibo">
      <PurchasePopup data-id="element-218" data-mp="3ik5nfqj3f6r6" />

      {/* Header / Hero Section */}
      <header className="bg-green-50 text-gray-800 pt-12 pb-16 px-4 text-center border-b border-green-100" data-id="element-219" data-mp="3eika642ncqgg">
        <div className="max-w-4xl mx-auto" data-id="element-220" data-mp="10c493fbs4li7">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 leading-tight text-green-800 uppercase tracking-tight" data-id="element-221" data-mp="1098cbubo42vc">
            Deja de Regalar Goles Evitables en Cada Partido
          </h1>

          <div className="relative max-w-2xl mx-auto mb-8" data-id="element-222" data-mp="1a3i5he8fp574">
            <a href="https://arquera-de-hockey-pro.impultienda.ar" className="block cursor-pointer" data-id="element-223" data-mp="1e1fwmmlrm1d5">
              <img src={MAIN_IMAGE} alt="Arquera de Hockey 360" className="w-[85%] h-auto mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-224" data-mp="hete46x6ke8k" />
            </a>
          </div>

          <h2 className="text-lg md:text-xl font-medium mb-8 text-gray-600 leading-snug max-w-2xl mx-auto" data-id="element-225" data-mp="vd18q86qv3gk">
            Las 5 áreas que definen un partido —salidas, córners, pelota
            elevada, distribución y mentalidad— con su corrección paso a paso.
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-226" data-mp="6odtcl8ftuqj">
            <span className="bg-white border border-green-200 px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 text-green-800 shadow-sm" data-id="element-227" data-mp="2nk67u2tkjyp">
              📄 100% PDF
            </span>
            <span className="bg-white border border-green-200 px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 text-green-800 shadow-sm" data-id="element-228" data-mp="bo8jgmke2gaj">
              ⚡️ Entrega Inmediata
            </span>
            <span className="bg-white border border-green-200 px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 text-green-800 shadow-sm" data-id="element-229" data-mp="3f58o1df308tj">
              📚 6 Módulos + 5 Bonos
            </span>
          </div>

          <CTAButton data-id="element-230" data-mp="3p23k7pnvtx4n" />
        </div>
      </header>

      {/* Problems Section */}
      <section className="py-16 px-4 bg-white" data-id="element-231" data-mp="31d0qvkjvyfub">
        <div className="max-w-3xl mx-auto" data-id="element-232" data-mp="31bps5z5arya2">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-4 text-green-800" data-id="element-233" data-mp="2weza569xmsm0">
            Conocemos la presión de estar debajo del arco
          </h2>
          <p className="text-center text-gray-500 mb-10 font-medium" data-id="element-234" data-mp="1buc20gk9hrxr">
            ¿Te sientes identificada con alguna de estas situaciones?
          </p>

          <div className="space-y-4" data-id="element-235" data-mp="12wrz736r3nl1">
            {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-4 bg-red-50 p-5 rounded-xl border border-red-200" data-id="element-236" data-mp="16wkahnnj47u3" data-mpi={idx}>
                <div className="bg-white p-2 rounded-full flex-shrink-0 mt-1 border border-red-200" data-id="element-237" data-mp="1ul3j64ahqmmp">
                  <ShieldAlert className="w-5 h-5 text-red-500" data-id="element-238" data-mp="1zjn4q3l69wej" />
                </div>
                <p className="text-red-700 font-semibold leading-relaxed" data-id="element-239" data-mp="1locex4lsc1h1">
                  {problem}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-16 px-4 bg-green-50" data-id="element-240" data-mp="f5wc2jd8pgk4">
        <div className="max-w-4xl mx-auto" data-id="element-241" data-mp="f7qvtucrz2mm">
          <div className="text-center mb-12" data-id="element-242" data-mp="15vzm0bvvhdld">
            <h2 className="text-3xl md:text-4xl font-black text-green-800 mb-4" data-id="element-243" data-mp="15xst1saedztw">
              El Sistema Completo: Arquera 360
            </h2>
            <p className="text-gray-500 font-medium" data-id="element-244" data-mp="wvjlnbafemkq">
              Todo lo que necesitás saber, organizado paso a paso.
            </p>
          </div>

          <Accordion items={modules} data-id="element-245" data-mp="ry18f8pdll6x" />

          <div className="mt-12" data-id="element-246" data-mp="1pk8njcjb2vxj">
            <CTAButton data-id="element-247" data-mp="1pki6ig5xo2tq" />
          </div>
        </div>
      </section>

      {/* Testimonials (now above the bonuses) */}
      <section className="py-16 px-4 bg-white" data-id="element-248" data-mp="1kmgntwcf65is">
        <div className="max-w-5xl mx-auto" data-id="element-249" data-mp="1fuf9m4voy4q4">
          <h2 className="text-3xl md:text-4xl font-black text-center text-green-800 mb-12" data-id="element-250" data-mp="1ft48kctmrb2p">
            Arqueras que ya transformaron su juego
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-251" data-mp="28agc8pm9dju7">
            {testimonials.map((t, idx) => <div key={idx} className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-252" data-mp="23iyjupyawrku" data-mpi={idx}>
                <div className="flex text-amber-400 mb-4" data-id="element-253" data-mp="2ax8zfu74le8t">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-254" data-mp="2fw291bjakl3p" data-mpi={i} />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-255" data-mp="2ps5cckpvqps8">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-256" data-mp="2pqc2yxnvtrgj">
                  <div className="w-10 h-10 bg-green-200 rounded-full flex items-center justify-center text-green-800 font-bold" data-id="element-257" data-mp="2tsz11gb5c8m6">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-258" data-mp="33jjwiuviwx0v">
                    <p className="font-bold text-gray-900" data-id="element-259" data-mp="33kbta90ux0sq">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-260" data-mp="38j6aj6j6ehaq">{t.city}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-green-50" data-id="element-261" data-mp="3hke8tolozi4t">
        <div className="max-w-4xl mx-auto" data-id="element-262" data-mp="kuaqfnm2l1nc">
          <div className="text-center mb-12" data-id="element-263" data-mp="kvm1m8huhboh">
            <h2 className="text-3xl md:text-4xl font-black text-green-800 mb-4" data-id="element-264" data-mp="ptdup5u873u9">
              Bonos Exclusivos
            </h2>
            <p className="text-gray-600 font-medium text-lg" data-id="element-265" data-mp="us8m2w69e0pz">
              Llévate estos 5 complementos{' '}
              <span className="text-green-700 font-bold underline decoration-green-400 decoration-4" data-id="element-266" data-mp="yv4ww0pk4sjd">
                GRATIS por el día de hoy
              </span>
              .
            </p>
          </div>

          <BonusAccordion bonuses={bonuses} data-id="element-267" data-mp="18qyhm7dfjsc8" />
        </div>
      </section>

      {/* Comparison table — below the bonuses, above the final offer */}
      <section className="py-12 px-4 bg-white" data-id="element-268" data-mp="1ii2w75z71b6j">
        <div className="max-w-3xl mx-auto" data-id="element-269" data-mp="1igrl0l3f515e">
          <h2 className="text-2xl md:text-3xl font-black text-center text-green-800 mb-6" data-id="element-270" data-mp="1mjo7imw2xhem">
            La diferencia es clara
          </h2>
          <ComparisonTable data-id="element-271" data-mp="1rjsnmbt2sa4b" />

          {/* Elite bonuses */}
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-272" data-mp="3c0s4k90rx0h0">
            {[{
            title: 'Calculadora de Proteínas e Hidratación',
            desc: 'Calcula al instante tu ingesta diaria de proteínas e hidratación según tu peso y carga de entrenamiento.'
          }, {
            title: 'Psicología Deportiva',
            desc: 'Herramientas mentales para competir con confianza, gestionar la presión y rendir bajo el arco.'
          }].map((bonus, i) => <div key={i} className="relative rounded-2xl border-2 border-green-300 bg-green-50 p-6 shadow-sm" data-id="element-273" data-mp="3qq7slh8x6rt0" data-mpi={i}>
                <span className="inline-flex items-center gap-1 bg-green-700 text-white text-[11px] font-black uppercase tracking-wide px-3 py-1 rounded-full mb-3" data-id="element-274" data-mp="3h0egmf4v8ao8">
                  <Crown className="w-3.5 h-3.5" data-id="element-275" data-mp="ibz34i1p2h52" /> Bono Elite
                </span>
                <h3 className="text-lg font-black text-green-800 leading-snug" data-id="element-276" data-mp="dhv029vjut99">
                  {bonus.title}
                </h3>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed" data-id="element-277" data-mp="11ehq88pi3n4l">
                  {bonus.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final Offer — order summary to maximize perceived value */}
      <section className="py-16 px-4 bg-green-50" data-id="element-278" data-mp="rmlis71iyknp">
        <div className="max-w-2xl mx-auto" data-id="element-279" data-mp="donfpxsnmani">
          <h2 className="text-3xl md:text-4xl font-black text-center text-green-800 mb-2" data-id="element-280" data-mp="dqzxa9ui2j01">
            Esto es todo lo que te llevas hoy
          </h2>
          <p className="text-center text-gray-500 font-medium mb-6" data-id="element-281" data-mp="4p0g9hjhjex3">
            Un sistema completo por una fracción de su valor real.
          </p>

          <CountdownTimer data-id="element-282" data-mp="8rwsmqifmesl" />

          <div className="bg-white border-2 border-green-300 rounded-2xl p-5 md:p-6 shadow-lg mt-6" data-id="element-283" data-mp="1z2j9if6hgbcl">
            {/* Summary list */}
            <ul className="divide-y divide-green-100" data-id="element-284" data-mp="232jxorjdw0wu">
              {[{
              icon: BookOpen,
              label: '6 Tomos en PDF',
              value: '$54.900'
            }, {
              icon: Gift,
              label: 'Bono 1 – Atlas Visual',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 2 – 50 Entrenamientos',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 3 – Autoevaluación',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 4 – Cuaderno de Partido',
              value: 'GRATIS',
              free: true
            }, {
              icon: Gift,
              label: 'Bono 5 – Corrección de Errores',
              value: 'GRATIS',
              free: true
            }, {
              icon: Crown,
              label: 'Bono Elite – Proteínas e Hidratación',
              value: 'GRATIS',
              free: true
            }, {
              icon: Crown,
              label: 'Bono Elite – Psicología Deportiva',
              value: 'GRATIS',
              free: true
            }].map((row, i) => {
              const Icon = row.icon;
              return <li key={i} className="flex items-center justify-between gap-3 py-2" data-id="element-285" data-mp="29marrfcwbz5n" data-mpi={i}>
                    <span className="flex items-center gap-2.5 text-sm text-gray-700" data-id="element-286" data-mp="2edsua7uki7sq">
                      <Icon className={`w-4 h-4 flex-shrink-0 ${row.free ? 'text-green-600' : 'text-gray-400'}`} data-id="element-287" data-mp="1gwlpyzsd3v2z" />
                      {row.label}
                    </span>
                    <span className={`text-sm font-bold flex-shrink-0 ${row.free ? 'text-green-600' : 'text-gray-400 line-through'}`} data-id="element-288" data-mp="1ecp1vmv2wvee">
                      {row.value}
                    </span>
                  </li>;
            })}
            </ul>

            {/* Price + buy button */}
            <div className="mt-4 pt-4 border-t border-green-200" data-id="element-289" data-mp="ve30s7zkb4ah">
              <CTAButton showPrice={true} data-id="element-290" data-mp="vgfqx8fh4kym" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ — collapsible */}
      <section className="py-16 px-4 bg-green-50" data-id="element-291" data-mp="lo9y5whedzid">
        <div className="max-w-3xl mx-auto" data-id="element-292" data-mp="lot8ar0t3jlu">
          <h2 className="text-3xl font-black text-center text-green-800 mb-10" data-id="element-293" data-mp="gpowdsmhz7rt">
            Preguntas Frecuentes
          </h2>
          <Accordion items={faqItems} data-id="element-294" data-mp="bpapwf0jo5vw" />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-green-800 text-green-100 py-12 text-center" data-id="element-295" data-mp="7oiilrb8gb29">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-296" data-mp="3t9awrjlirpb6">
          <Settings className="w-5 h-5" data-id="element-297" data-mp="3tb5kt6s37xjh" />
          <span className="font-medium" data-id="element-298" data-mp="239k56lwonnf">Soporte: EbookDreamShop@gmail.com</span>
        </div>
        <p className="text-sm mt-4 text-green-200" data-id="element-299" data-mp="3k8w8cbd9du3g">
          © {new Date().getFullYear()} Arquera de Hockey 360. Todos los
          derechos reservados.
        </p>
        <p className="text-xs mt-2 max-w-2xl mx-auto px-4 text-green-300/70" data-id="element-300" data-mp="3p9aj4168vi56">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}